<template>
  <div class="content-container">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>配置</el-breadcrumb-item>
      <el-breadcrumb-item>处理流程</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel mt-20">
      <div class="filter">
        <el-form
          :inline="true"
          :model="filter"
          ref="filterForm"
          label-position="left"
          label-width="70px"
          @submit.native.prevent
          size="small"
        >
          <el-form-item label="流程状态" prop="status">
            <el-select v-model="filter.status">
              <el-option label="启用" :value="1" key="1"></el-option>
              <el-option label="禁用" :value="2" key="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="流程名称" prop="name">
            <el-input
              v-model="filter.name"
              placeholder="流程名称"
              @keyup.enter.native="requestData"
            ></el-input>
          </el-form-item>
          <el-form-item label="流程分组" prop="group_name">
            <el-select v-model="filter.group_name" clearable>
              <el-option label="保内" value="保内" key="1"></el-option>
              <el-option label="保外" value="保外" key="2"></el-option>
              <el-option label="其他" value="其他" key="3"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="mt-10">
          <el-button type="primary" size="small" @click="requestData"
            >筛选</el-button
          >
          <el-button size="small" @click="reset()">重置</el-button>
        </div>
      </div>
    </div>
    <div class="panel mt-20">
      <div class="header mb-10">
        <el-button
          @click="handleEdit()"
          type="primary"
          icon="el-icon-plus"
          size="small"
          v-permission="Auth.serviceQuestFlowNew"
          >新增流程</el-button
        >
      </div>
      <div v-loading="loading" style="min-height: 50px">
        <el-collapse>
          <el-collapse-item
            v-for="(item, index) in flows"
            :key="item.id"
            :name="item.id"
          >
            <div
              slot="title"
              style="
                width: 100%;
                display: flex;
                justify-content: space-between;
                padding-right: 10px;
              "
            >
              <div>
                {{ item.name }}
                <el-tag type="primary" size="mini" effect="plain">{{
                  item.group_name
                }}</el-tag>
              </div>
              <div>
                <el-popconfirm
                  v-permission="Auth.serviceQuestFlowEdit"
                  :title="`确认${item.status == 2 ? '启用' : '禁用'}该流程吗？`"
                  @confirm="handleSwitchStatus(index, item)"
                >
                  <el-button
                    slot="reference"
                    class="mr-5"
                    :type="item.status == 2 ? 'danger' : 'primary'"
                    plain
                    size="mini"
                    @click.stop
                    >{{ item.status == 2 ? '启用' : '禁用' }}</el-button
                  >
                </el-popconfirm>
                <el-popconfirm
                  v-permission="Auth.serviceQuestFlowEdit"
                  v-if="item.status == 1"
                  title="确认复制该流程吗？"
                  @confirm="handleCopy(index, item)"
                >
                  <el-button
                    slot="reference"
                    type="primary"
                    class="mr-5"
                    plain
                    size="mini"
                    @click.stop
                    >复制</el-button
                  >
                </el-popconfirm>
                <el-button
                  type="primary"
                  size="mini"
                  plain
                  v-permission="Auth.serviceQuestFlowEdit"
                  @click.stop="handleEdit(item, index)"
                  v-if="item.status == 1"
                  >编辑</el-button
                >
              </div>
            </div>
            <div class="flow-container">
              <StepTree
                :steps="arrayToTree(item.steps, 0)"
                :all-steps="arrayToTree(item.steps, 0)"
                :flowid="item.id"
                :isoutflow="item.relative_fileds.includes(1)"
              ></StepTree>
            </div>
          </el-collapse-item>
        </el-collapse>
        <div
          v-if="!loading && flows.length == 0"
          style="text-align: center; line-height: 80px"
        >
          无数据
        </div>
      </div>
    </div>
    <Former
      :model="model"
      :show.sync="formerVisible"
      @created="createdModel"
      @updated="updatedModel"
    ></Former>
  </div>
</template>

<script>
import {
  serviceQuestFlowList,
  serviceQuestFlowStatus,
  serviceQuestFlowCopy,
} from '../../../service/getData'
import Former from './former.vue'
import StepTree from './stepTree.vue'
import store from '@/store/store'

export default {
  components: {
    Former,
    StepTree,
  },
  data() {
    return {
      filter: {
        name: '',
        group_name: '',
        status: 1,
      },
      formerVisible: false,
      editIndex: 0,
      model: {
        name: '',
        group_name: '',
        relative_fileds: [],
      },
      flows: [],
      loading: false,
    }
  },
  computed: {
    editStep() {
      return store.state.editStep
    },
  },
  watch: {
    editStep: function () {
      let editFlow = store.state.editStep
      let flow = this.flows.filter((item) => item.id == editFlow.id)[0]
      let index = this.flows.indexOf(flow)
      this.$set(this.flows, index, editFlow)
    },
  },
  created() {
    this.requestData()
  },
  methods: {
    async requestData() {
      let filter = this.clone(this.filter)
      this.loading = true
      let res = await serviceQuestFlowList(filter)
      this.loading = false
      if (res.code == 0) {
        this.flows = res.data.list
      }
    },
    reset() {
      this.$refs['filterForm'].resetFields()
      this.requestData()
    },
    handleEdit(item, index) {
      this.editIndex = 0
      if (item) {
        this.editIndex = index
        this.model = this.clone(item)
      } else {
        this.model = {
          name: '',
          group_name: '',
          relative_fileds: [],
          is_show_in_mini: 1,
        }
      }
      this.formerVisible = true
    },
    createdModel(res) {
      this.flows.unshift(res)
    },
    updatedModel(res) {
      this.$set(this.flows, this.editIndex, res)
    },
    async handleSwitchStatus(index, item) {
      let res = await serviceQuestFlowStatus(item.id)
      if (res.code == 0) {
        this.flows.splice(index, 1)
        this.$message.success(`流程已${item.status == 1 ? '禁用' : '启用'}`)
      }
    },
    async handleCopy(index, item) {
      let res = await serviceQuestFlowCopy(item.id)
      if (res.code == 0) {
        this.flows.unshift(res.data)
      }
    },
    arrayToTree(list, root) {
      const result = [] // 用于存放结果
      const map = {} // 用于存放 list 下的节点

      // 1. 遍历 list，将 list 下的所有节点以 id 作为索引存入 map
      for (const item of list) {
        map[item.id] = { ...item } // 浅拷贝
      }

      // 2. 再次遍历，将根节点放入最外层，子节点放入父节点
      for (const item of list) {
        // 3. 获取节点的 id 和 父 id
        const { id, father_id } = item // ES6 解构赋值
        // 4. 如果是根节点，存入 result
        if (item.father_id === root) {
          result.push(map[id])
        } else {
          // 5. 反之，存入到父节点
          map[father_id].children
            ? map[father_id].children.push(map[id])
            : (map[father_id].children = [map[id]])
        }
      }

      // 将结果返回
      return result
    },
  },
}
</script>

<style scoped>
.flow-container {
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
}

/* .step-group-container {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  gap: 10px;
}
.step-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.close-btn {
  position: absolute;
  right: 2px;
  top: 2px;
}

.fix-input {
  max-width: 100px;
} */
</style>